import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pass-restricted-checkbox-texts',
  templateUrl: './pass-restricted-checkbox-texts.component.html',
  styleUrl: './pass-restricted-checkbox-texts.component.scss'
})
export class PassRestrictedCheckboxTextsComponent {
  @Input() textKey!: PassRestrictedCheckboxTextKey;
}

export type PassRestrictedCheckboxTextKey = "PROXY_TITLE" | "YES" | "NO" | "BIOMETRIE_FINGERABDRUECKE_TITLE" | "BIOMETRIE_FINGERABDRUECKE_YES" | "BIOMETRIE_FINGERABDRUECKE_NO" | "KONTAKTDATEN_WOHNSITZ_TITLE" | "KONTAKTDATEN_WOHNSITZ_YES" | "KONTAKTDATEN_WOHNSITZ_NO";
